import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ab4f3df0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ab4f3df0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4f3df0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab4f3df0')) {
      api.createRecord('ab4f3df0', component.options)
    } else {
      api.reload('ab4f3df0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ab4f3df0&scoped=true", function () {
      api.rerender('ab4f3df0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/thirdOrder/index.vue"
export default component.exports